<ul class="partner-logo-list partner-logo-list--columns-{{ columns() }}">
  @for (partner of highlightedPartners(); track $index) {
    <li class="partner-logo-list__item">
      @if (partner.link) {
        <a
          [href]="partner.link.href"
          class="partner-logo-list__link"
          target="_blank"
        >
          <ng-container [ngTemplateOutlet]="partnerLogo" />
        </a>
      } @else {
        <ng-container [ngTemplateOutlet]="partnerLogo" />
      }

      <ng-template #partnerLogo>
        <img
          [alt]="partner.image.alt"
          [src]="partner.image.src"
          class="partner-logo-list__item-picture"
        />
      </ng-template>
    </li>
  }
</ul>
